import React from 'react';

const ManageAllOrders = () => {
    return (
        <div>
            <h1 className="text-center text-primary p-d my-5">Manage All Order Page By Admin</h1>
        </div>
    );
};

export default ManageAllOrders;